import {Injectable} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmDialogComponent} from './confirm-dialog.component';

export interface ConfirmOptions {
  title: string;
  message?: string;
  confirmLabel?: string;
  danger?: boolean;
}

/**
 * In-app replacement for window.confirm(). Resolves true when the user confirms.
 */
@Injectable({providedIn: 'root'})
export class ConfirmService {

  constructor(private modal: NgbModal) {
  }

  confirm(options: ConfirmOptions): Promise<boolean> {
    const ref = this.modal.open(ConfirmDialogComponent, {centered: true, size: 'sm', windowClass: 'app-sheet'});
    Object.assign(ref.componentInstance, options);
    return ref.result.then(result => result === true, () => false);
  }
}
